import React from 'react'
import makeStyles from '@mui/styles/makeStyles';
import Button from "@mui/material/Button";
import Google from '@mui/icons-material/Google';

import { useGoogleLogin } from '@react-oauth/google';

const useStyles = makeStyles((theme) => ({
	loginButton: {
		width: "18rem"
	}
}));


const GoogleBtn = ({ login, signup }) => {

	const classes = useStyles();

	const handleLoginFailure = response => {
		console.log(response)
	}

	const googleLogin = useGoogleLogin({
		onSuccess: response => {
			try {
				if (response.access_token) {
					fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
						headers: {
							'Authorization': `Bearer ${response.access_token}`
						}
					})
						.then(res => res.json())
						.then(data => {
							if (data.sub) {
								const userData = {
									accessToken: response.access_token,
									profileObj: {
										name: data.name,
										googleId: data.sub,
										email: data.email,
									}
								};
								login(userData);
							}
						})
						.catch(err => {
							console.error("Error fetching Google user data: ", err);
							handleLoginFailure(err);
						});
				}
			} catch (error) {
				console.error("Error: ", error);
				handleLoginFailure(error);
			}
		},
		ux_mode: 'popup',
		onError: error => {
			console.error("Login Failed: ", error);
			handleLoginFailure(error);
		},
	});

	return (
		<div
			style={{ marginBottom: "1rem" }}
		>
			<Button
				variant="outlined"
				color="primary"
				className={classes.loginButton}
				endIcon={<Google />}
				onClick={() => googleLogin()}
			>
				{signup ? 'Sign Up with Google' : 'Login with Google'}
			</Button>
		</div>
	)
}


export default GoogleBtn;